import React from 'react';

import { IconButton } from 'toolkit/chakra/icon-button';
import IconSvg from 'ui/shared/IconSvg';
import * as cookies from 'lib/cookies';
import { useColorMode } from 'toolkit/chakra/color-mode';

const ThemeToggle = () => {
  const { colorMode, setColorMode } = useColorMode();

  const toggleColorMode = React.useCallback(() => {
    const nextColorMode = colorMode === 'light' ? 'dark' : 'light';
    setColorMode(nextColorMode);
    cookies.set(cookies.NAMES.COLOR_MODE, nextColorMode);
    window.localStorage.setItem(cookies.NAMES.COLOR_MODE, nextColorMode);
  }, [colorMode, setColorMode]);

  return (
    <IconButton
      variant="link"
      size="2xs"
      borderRadius="sm"
      aria-label="Toggle color mode"
      onClick={toggleColorMode}
    >
      <IconSvg name={colorMode === 'light' ? 'moon' : 'sun'} />
    </IconButton>
  );
};

export default React.memo(ThemeToggle);
